import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexGrow: 1,
    borderTop: `solid 1px ${theme.palette.divider}`,
    overflow: 'hidden',

    '& > .content': {
      display: 'grid',
      width: '100%',
      gridTemplate: `
        "topbar sidemenu" ${theme.spacing(8)}px
        "wrapper sidemenu" auto / 1fr auto
      `,

      '&.without-sidemenu': {
        gridTemplate: `
          "topbar sidemenu" ${theme.spacing(8)}px
          "wrapper wrapper" auto / 1fr auto
        `,
      },

      '&.course-empty': {
        display: 'flex',
      },

      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        flexDirection: 'column',
      },

      '& > .content-wrapper': {
        gridArea: 'wrapper',
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        overflow: 'hidden',

        '& > .content-scrollable': {
          flexGrow: 1,
          overflow: 'auto',
          position: 'relative',
          WebkitOverflowScrolling: 'touch',
          overscrollBehavior: 'auto',

          '&.flexible': {
            display: 'flex',
            flexDirection: 'column',
          },

          [theme.breakpoints.up('md')]: {
            ...theme.globalStyles.scrollbar(theme),
          },
        },
      },
    },

    '& .container-section': {
      margin: theme.spacing(4),

      [theme.breakpoints.down('sm')]: {
        margin: theme.spacing(2),
      },

      [theme.breakpoints.down('xs')]: {
        margin: theme.spacing(2, 0),
      },
    },
  },

  '.app-toolbar': {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}));

export default styles;
